export default "__VITE_ASSET__54VACfVU__"